import React from "react";
import PropTypes from "prop-types";
// import DeclarationField from "pages/Consumer/ApplicationType/PermanentConnection/DeclarationField";
import DeclarationField from "./DeclarationField";

const declarationsForPower = [
  {
    description:
      "Electricity dues outstanding in Licensees area of operation in consumers name :",
    name: "consumerDuesOutstanding",
    selectFieldName: "isConsumerDuesOutstanding",
    placeholder: "Consumer Number",
  },
  {
    description:
      "Electricity dues outstanding for the premises for which connection applied for :",
    name: "premisesDuesOutstanding",
    selectFieldName: "isPremisesDuesOutstanding",
    placeholder: "Consumer Number",
  },
  {
    description:
      "Any electricity dues outstanding with the Licensees against any firm with which the consumer is associated as an Owner, Partner, Director or Managing Director :",
    name: "firmDuesOutstanding",
    selectFieldName: "isFirmDuesOutstanding",
    placeholder: "Consumer Number",
  },
];

const declarationsForOtherUtilities = [
  {
    description: "Utility dues outstanding in GIFT City area of operation :",
    name: "consumerDuesOutstanding",
    selectFieldName: "isConsumerDuesOutstanding",
    placeholder: "Consumer Number",
  },
  {
    description:
      "Utility dues outstanding for the premises for which connection applied :",
    name: "premisesDuesOutstanding",
    selectFieldName: "isPremisesDuesOutstanding",
    placeholder: "Consumer Number",
  },
];

const Declaration = ({ formik }) => {
  const {
    values: { utilityId },
  } = formik;

  return (
    <>
      {utilityId
        ? declarationsForPower.map((item) => (
            <DeclarationField item={item} formik={formik} key={item.name} />
          ))
        : declarationsForOtherUtilities.map((item) => (
            <DeclarationField item={item} formik={formik} key={item.name} />
          ))}
    </>
  );
};

Declaration.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default Declaration;
